import { ParentModule } from "@/ts/common-types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const titleSlice = createSlice({
    name: "title",
    initialState: { value: ParentModule.PERFORMANCE_OVERVIEW as string },
    reducers: {
        updateTitle: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

export const { updateTitle } = titleSlice.actions;
export default titleSlice.reducer;
